module.exports = __webpack_public_path__ + "img/PILOTOS.40752ca5.png";